var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#twitter_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7FAF3",
    fillRule: "evenodd",
    d: "M10 0c5.52 0 10 4.48 10 10s-4.48 10-10 10S0 15.52 0 10 4.48 0 10 0M8.239 15.319c4.425 0 6.844-3.667 6.844-6.845q.001-.159-.005-.31c.47-.339.878-.763 1.203-1.246-.43.19-.893.319-1.382.379.499-.3.878-.769 1.057-1.332a4.9 4.9 0 0 1-1.526.583 2.406 2.406 0 0 0-4.096 2.195c-2-.1-3.772-1.057-4.959-2.514a2.4 2.4 0 0 0-.324 1.207c0 .833.424 1.572 1.072 2a2.36 2.36 0 0 1-1.087-.298v.03c0 1.167.828 2.135 1.93 2.36a2.4 2.4 0 0 1-1.087.04 2.4 2.4 0 0 0 2.245 1.67 4.84 4.84 0 0 1-3.562.993 6.7 6.7 0 0 0 3.677 1.088",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "twitter_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgTwitter;